import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Section from "components/section";
import {
  Typography,
  TableContainer,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Grid,
  Link,
  TextField,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";

// Navigation
import NavCrumbs from "./proposals-all-proposals-nav-crumbs";

//InstantSearch
import { getSearchClient } from "utils/algolia";
import {
  InstantSearch,
  connectSearchBox,
  connectHits,
  connectPagination,
  Stats,
  RefinementList,
} from "react-instantsearch-dom";

// Styles
// import styles from "./vacancies-all-vacancies-styles";
import styles from "routes/dashboard/dashboard-styles";
import moment from "moment";

const useStyles = makeStyles(styles);

const searchClient = getSearchClient();

export default function (props) {
  const classes = useStyles();
  const {
    user,
    loading,
    status,
    proposals,
    onPressedDeleteItem,
    sectionDescription,
    refreshAlgolia,
    toggleAddProposalForm,
    onPressedItem,
  } = props;

  React.useEffect(() => {
    searchClient.clearCache();
  }, []);

  const Pagination = ({ currentRefinement, nbPages, refine, createURL }) => (
    <Grid container spacing={3}>
      <Grid item xs={2}></Grid>

      <Grid item xs={8} className={classes.pagination}>
        <ul className={classes.paginationList}>
          {currentRefinement > 1 && (
            <li className={classes.paginationListItem}>
              <Link
                href={createURL(currentRefinement - 1)}
                onClick={(event) => {
                  event.preventDefault();
                  refine(currentRefinement - 1);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.143"
                  >
                    <path d="M9 5H1M5 9L1 5l4-4" />
                  </g>
                </svg>
              </Link>
            </li>
          )}
          {new Array(nbPages).fill(null).map((_, index) => {
            const page = index + 1;
            return (
              <li
                key={index}
                className={
                  currentRefinement === page
                    ? classes.paginationListItemActive
                    : classes.paginationListItem
                }
              >
                <Link
                  href={createURL(page)}
                  onClick={(event) => {
                    event.preventDefault();
                    refine(page);
                  }}
                >
                  {page}
                </Link>
              </li>
            );
          })}
          {nbPages > 1 && currentRefinement < nbPages && (
            <li className={classes.paginationListItem}>
              <Link
                href={createURL(currentRefinement + 1)}
                onClick={(event) => {
                  event.preventDefault();
                  refine(currentRefinement + 1);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.143"
                  >
                    <path d="M1 5h8M5 9l4-4-4-4" />
                  </g>
                </svg>
              </Link>
            </li>
          )}
        </ul>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
  const CustomPagination = connectPagination(Pagination);

  const SearchBox = ({ currentRefinement, refine }) => {
    return (
      <TextField
        type="search"
        variant="outlined"
        label="Search for a Proposal"
        value={currentRefinement}
        fullWidth
        onChange={(event) => refine(event.currentTarget.value)}
        className={classes.searchBar}
      />
    );
  };

  const CustomSearchBox = connectSearchBox(SearchBox);

  const Hits = ({ hits, refineNext }) => {
    return (
      <TableBody>
        {hits.map((row, index) => {
          let typeColor = "32CD32";
          if (status == "pending") {
            typeColor = "e8e8e8";
          }
          if (status == "successful") {
            typeColor = "3FD186 ";
          }
          if (status == "unsuccessful") {
            typeColor = "C70039";
          }

          return (
            <TableRow hover key={row.objectID} className={classes.row}>
              <TableCell
                onClick={(event) => onPressedItem(row.objectID)}
                className={classes.cellType}
                align="left"
                style={{ borderLeft: `3px solid #${typeColor}` }}
              >
                {row.title}
              </TableCell>
              <TableCell
                onClick={(event) => onPressedItem(row.objectID)}
                className={classes.cellType}
                align="left"
              >
                {row.clientTitle}
              </TableCell>
              <TableCell
                onClick={(event) => onPressedItem(row.objectID)}
                className={classes.cellType}
                align="left"
              >
                {row.type ? row.type : ""}
              </TableCell>
              {user.roles.indexOf("admin") >= 0 && (
                <TableCell
                  onClick={(event) => onPressedItem(row.objectID)}
                  className={classes.cellType}
                  align="left"
                >
                  {row.prices && row.prices.length > 0
                    ? `€ ${row.prices
                        .map((item) => item.value)
                        .reduce((prev, next) => prev + next)}`
                    : ""}
                </TableCell>
              )}
              <TableCell
                onClick={(event) => onPressedItem(row.objectID)}
                className={classes.cellType}
                align="left"
              >
                {row.submissionDate
                  ? moment(row.submissionDate).format("DD MMM YYYY")
                  : ""}
              </TableCell>

              <TableCell className={classes.selectRight} align="right">
                <IconButton
                  aria-label="delete"
                  color="primary"
                  onClick={(event) => {
                    onPressedDeleteItem(row.objectID);
                  }}
                >
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  const CustomHits = connectHits(Hits);

  return (
    <NavCrumbs>
      <Section
        title="MANAGE YOUR PROPOSALS"
        loading={loading}
        sectionDescription={sectionDescription}
        actionName="Add Proposal"
        handleAction={toggleAddProposalForm}
      >
        {proposals.length > 0 && (
          <InstantSearch
            indexName="Proposals"
            searchClient={searchClient}
            refresh={refreshAlgolia}
          >
            <RefinementList
              attribute="status"
              operator="or"
              defaultRefinement={status}
            />

            <Stats
              translations={{
                stats(nbHits, processingTimeMS, nbSortedHits, areHitsSorted) {
                  return (
                    <Typography className={classes.stat}>
                      {nbHits} {status}
                    </Typography>
                  );
                },
              }}
            />
            <CustomSearchBox />

            <Paper className={classes.tablePaper}>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        {" "}
                        <Typography className={classes.labelText}>
                          Proposal
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        <Typography className={classes.labelText}>
                          Client
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        <Typography className={classes.labelText}>
                          Type
                        </Typography>
                      </TableCell>
                      {user.roles.indexOf("admin") >= 0 && (
                        <TableCell align="left">
                          <Typography className={classes.labelText}>
                            Value
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell align="left">
                        {" "}
                        <Typography className={classes.labelText}>
                          Submission Date
                        </Typography>
                      </TableCell>

                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <CustomHits />
                </Table>
              </TableContainer>
            </Paper>
            <CustomPagination />
          </InstantSearch>
        )}
        {proposals.length === 0 && (
          <Typography className={classes.emptyText} align="center">
            You haven't created any proposals yet.
          </Typography>
        )}
      </Section>
    </NavCrumbs>
  );
}
